import React, { useRef, useState } from 'react';
import Heading from '../../components/common/Heading/Heading';
import DynamicTableAnt from '../../hooks/DynamicTableAnt';
import { App, Button, DatePicker, Flex, Input, Popconfirm, Popover, Space, Tag } from 'antd';
import { MdModeEditOutline, MdDelete, MdCancel } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { queryKeys } from '../../services/react-query/queryKeys';
import {
  deleteEncounters,
  getEncounters,
  submitEncounter,
} from '../../network/encounters';
import { TiCancel } from "react-icons/ti";
import { colorPrimary, getTimeFormat } from '../../utils/utils';
import { FaCalendarCheck } from 'react-icons/fa';
import StatusTag from '../../hooks/StatusHook';
import { SearchOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { cancelMaterialRequest } from '../../network/materialRequest';
const Encounters = ({ t }) => {
  const navigate = useNavigate();
  const { message } = App.useApp();
  const client = useQueryClient();
  const [textValue, setTextValue] = useState('');
  const searchInput = useRef(null);
  const searchInputMobile = useRef(null);
  const [searchText, setSearchText] = useState({
    value: '',
    key: '',
  });
  const { data, isLoading } = useQuery({
    queryKey: [queryKeys.getEncountersList,searchText.key, searchText.value],
    queryFn: () => getEncounters({key:searchText.key, value:searchText.value}),
    keepPreviousData: true,
  });
  const  handleCancel = useMutation(
    // (id) => deletePatient(id),
    {
      mutationFn: (name) => cancelMaterialRequest("Patient Encounter",name),
      onSuccess: (data) => {
        console.log(data, 'data');
        if (data?.message?.status === 500) {
          message.error(data?.message?.message);
          return false;
        }
        message.success("Cancelled successfully");
        client.invalidateQueries({ queryKey: [queryKeys.getEncountersList] });
      },
      onError: () => {
        message.error('Something went wrong!');
      },
    }
  );
  const handleRemove = useMutation(
    // (id) => deletePatient(id),
    {
      mutationFn: (id) => deleteEncounters(id),
      onSuccess: (data) => {
        console.log(data, 'data');
        if (data?.message?.status === 500) {
          message.error(data?.message?.message);
          return false;
        }
        message.success(data?.message?.message);
        client.invalidateQueries({ queryKey: [queryKeys.getEncountersList] });
      },
      onError: () => {
        message.error('Something went wrong!');
      },
    }
  );
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText({ value: selectedKeys[0], key: dataIndex });
  };
  const handleReset = (clearFilters, confirm) => {
    confirm();
    setTextValue('');
    clearFilters();
    setSearchText({ value: '', key: '' });
  };

  const { mutate: onSubmitEncounter } = useMutation({
    mutationKey: ['submitEncounter'],
    mutationFn: (name) => submitEncounter(name),
    onSuccess: (data) => {
      //  console.log(data, 'data');
      console.log(data?.message, 'data');
      //  console.log(data?.message?.status, 'data');
      if (data?.message?.status === 500 || data?.message?.status === 417) {
        // console.log(data?.message?.status, 'data');
        message.error(data?.message?.message);
        return false;
      }
      data?.message?.message && message.success(data?.message?.message);
      client.invalidateQueries({
        queryKey: [queryKeys.getEncountersList],
      });
    },
    onError: (error) => {
      message.error(error);
    },
  });
  const props = ({key,name}) => ({
    filterIcon: () => <SearchOutlined color={colorPrimary} />,
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInputMobile}
          placeholder={name}
          value={textValue}
          onChange={(e) => {
            setSelectedKeys(e.target.value ? [e.target.value] : []);
            setTextValue(e.target.value);
          }}
          onPressEnter={() => handleSearch(selectedKeys, confirm, key)}
          style={{
            marginBottom: 8,
            display: 'block',
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, key)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            {t.Search}
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters, confirm)}
            size="small"
            style={{
              width: 90,
            }}
          >
            {t.Reset}
          </Button>
        </Space>
      </div>
    ),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTextValue('');
        setSearchText({ value: '', key: '' });
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
  })
  const columns = [
    {
      title: t.encounterID,
      dataIndex: 'name',
     ...props({key:'name',name:t.encounterID}),
     render: (text, record) => {
      return (
        <span
          style={{ cursor: 'pointer' }}
          className="text-primary"
          onClick={() => {
            navigate(`/encounters/${record.name}`);
          }}
        >
          {text}
        </span>
      );
    },
    },
    {
      title: t.patient,
      dataIndex: 'patient_name',
      ...props({key:'patient_name',name:t.patient}),
    },
    {
      title: t.encounterDate,
      dataIndex: 'encounter_date',
      // ...props({key:'encounter_date'}),
      filterIcon: () => <SearchOutlined color={colorPrimary} />,
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <div
          style={{
            padding: 8,
          }}
          onKeyDown={(e) => e.stopPropagation()}
        >
          <Flex vertical gap={16}>
            <DatePicker
              onChange={(date) => {
                console.log(dayjs(date)?.format('YYYY-MM-DD'), 'encounter_date');
                if (date) {
                  setSearchText({
                    value: dayjs(date)?.format('YYYY-MM-DD'),
                    key: 'encounter_date',
                  });
                } else {
                  setSearchText({ value: '', key: '' });
                }
              }}
            />
          </Flex>
        </div>
      ),
      onFilterDropdownOpenChange: (visible) => {
        if (visible) {
          setTextValue('');
          setSearchText({ value: '', key: '' });
          setTimeout(() => searchInput.current?.select(), 100);
        }
      },
    },
    {
      title: t.encounterTime,
      dataIndex: 'encounter_time',
      render: (time) => {
        return <Tag color={colorPrimary}>{getTimeFormat(time)}</Tag>;
      },
    },
    {
      title: t.healthcarePractitioner,
      dataIndex: 'practitioner_name',
      ...props({key:'practitioner_name',name:t.healthcarePractitioner}),
    },
    {
      title: t.department,
      dataIndex: 'medical_department',
      ...props({key:'medical_department',name:t.department}),
    },
    {
      title: t.status,
      dataIndex: 'docstatus',
      render: (status) => <StatusTag status={status} />,
    },
    {
      title: t.action,
      dataIndex: 'action',
      key: 'action',
      render: (text, record) => {
        // console.log('record:', record);
        const enable_submit = record?.docstatus === 0 ? true : false;
        return (
          <Space>
            <Popover
              placement="top"
              title={t.edit}
              onClick={() => navigate(`/encounters/${record.name}`)}
            >
              <Button
                size="small"
                type="primary"
                // onClick={() => navigate(`/patients/${record.uid}`)}
              >
                <MdModeEditOutline />
              </Button>
            </Popover>
            {
              record?.docstatus !== 1 &&
              <Popconfirm
              title={t.DeletetheEncounter}
              description={t.AreyousuretodeletethisEncounter}
              onConfirm={() => handleRemove.mutate(record.name)}
              // onCancel={cancel}
              okText="Yes"
              cancelText="No"
              >
              <Button size="small" type="primary" danger
               icon={<MdDelete />}
              />
                
            </Popconfirm>
            }
            {
              record?.docstatus === 1 &&
              <Popconfirm
              title={t.canceltheEncounter}
              description={t.AreyousuretoCancelthisEncounter}
              onConfirm={() => handleCancel.mutate(record.name)}
              // onCancel={cancel}
              okText="Yes"
              cancelText="No"
              >
              <Button size="small" type="primary" danger
               icon={<TiCancel />}
              />
            </Popconfirm>
            }
            {enable_submit && (
              <Popover placement="top" title={t.submit}>
                <Popconfirm
                  title={t.SubmittheEncounter}
                  description={t.AreyousuretobesubmitthisEncounter}
                  onConfirm={() => onSubmitEncounter(record?.name)}
                  // onCancel={cancel}
                  okText={t.yes}
                  cancelText={t.no}
                >
                  <Button
                    size="small"
                    type="primary"
                    style={{ backgroundColor: '#28a745', border: 0 }}
                  >
                    <FaCalendarCheck />
                  </Button>
                </Popconfirm>
              </Popover>
            )}
          </Space>
        );
      },
    },
  ];
  const dataTable =
    data?.data?.map((item, index) => ({
      key: index,
      ...item,
    })) || [];
  return (
    <div className="encounters">
      <Heading title={t.Healthcare} subTitle={t.Encounters} path="/" />
      <DynamicTableAnt
        columns={columns}
        data={dataTable}
        loading={isLoading}
        setSearchText={setSearchText}
        titleBtn={t.addEncounter}
        Placeholder={t.searchEncounter}
        pathBtn="/encounters/add"
      />
    </div>
  );
};

export default Encounters;
